export default "https://fenwan.cdn.bcebos.com/gamecenter/static/game/assets/imgs/book_success.51ceb4f3.png";